// Layout optimizado para escritorio
// Incluye navbar, sidebar vertical y footer consistentes
// Maneja la actualización de ubicación del usuario con Explorer

import React, { memo } from 'react';
import NavbarVertical from '../Navigation/NavbarVertical';
import Alert from '../UI/Alert';
import BannerPromotional from '../ecommerce/BannerPromotional';

/**
 * Componente DesktopLayout
 * 
 * Layout optimizado para dispositivos de escritorio
 * Estructura: Navbar (top) + Sidebar vertical (left) + Content (right)
 * 
 * @param {Object} props - Props del componente
 * @param {React.ReactNode} props.children - Contenido de la página
 * @param {Object} props.locationData - Datos de ubicación (compartido desde MainLayout)
 * @param {Function} props.requestLocationPermission - Función para solicitar permisos (compartido desde MainLayout)
 * @param {boolean} props.showPermissionAlert - Estado de alerta de permisos (compartido desde MainLayout)
 * @param {boolean} props.loading - Estado de carga (compartido desde MainLayout)
 * @param {Function} props.onDismissAlert - Función para cerrar alerta (compartido desde MainLayout)
 */
const DesktopLayout = ({ 
  children, 
  locationData, 
  requestLocationPermission, 
  showPermissionAlert, 
  loading,
  onDismissAlert 
}) => {
  return (
    <div className="min-h-screen bg-neutral-900 flex flex-col">

      {/* Alerta de permisos de geolocalización */}
      {showPermissionAlert && (
        <div className="fixed top-4 right-4 z-50 max-w-md">
          <Alert
            type="warning"
            title="Permiso de ubicación requerido"
            message="Para mostrar usuarios cercanos correctamente, necesitamos acceder a tu ubicación."
            dismissible={true}
            onDismiss={onDismissAlert}
          >
            <button
              onClick={requestLocationPermission}
              disabled={loading}
              className="mt-3 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-sm font-medium disabled:opacity-50"
            >
              {loading ? 'Obteniendo ubicación...' : 'Habilitar ubicación'}
            </button>
          </Alert>
        </div>
      )}

      {/* <Navbar /> */}

      {/* Contenedor principal con sidebar y contenido */}
      <div className="flex flex-1">
        {/* Sidebar vertical */}
        <NavbarVertical />

        {/* Área de contenido principal - con margen izquierdo para el sidebar */}
        <main className="flex-1 ml-64">
          {children}

          <div className='fixed bottom-0 left-64 right-0 z-10'>
            <BannerPromotional />
          </div>
        </main>
      </div>
    </div>
  );
};

// Memoizar DesktopLayout para prevenir re-renders innecesarios
export default memo(DesktopLayout, (prevProps, nextProps) => {
  return prevProps.children === nextProps.children &&
         prevProps.showPermissionAlert === nextProps.showPermissionAlert &&
         prevProps.loading === nextProps.loading;
});
